import type { ReactNode } from 'react';

import styles from './InputGroup.module.css';

export interface InputGroupProps {
  ariaLabel?: string;
  /** 中间的输入控件（通常是 `Input`），自动占满剩余宽度。 */
  children: ReactNode;
  className?: string;
  /** Figma Mixed-input `Front slot`：前置标签，浅灰底、16 内边距、仅左侧圆角。 */
  frontSlot?: ReactNode;
  /** Figma Mixed-input `Rear slot`：后置标签，浅灰底、16 内边距、仅右侧圆角。 */
  rearSlot?: ReactNode;
}

/**
 * 前后置标签的组合输入框，对应 Figma `Mixed-input`。
 * 用于 ¥、元、https://、.com 等短前后缀。
 * 长句式条件使用普通文字穿插独立输入框，不把整句话放入槽位。
 */
export function InputGroup({ ariaLabel, children, className, frontSlot, rearSlot }: InputGroupProps) {
  return <span aria-label={ariaLabel} className={[styles.root, className].filter(Boolean).join(' ')} role="group">
    {frontSlot ? <span className={styles.slot} data-side="front">{frontSlot}</span> : null}
    <span className={styles.control}>{children}</span>
    {rearSlot ? <span className={styles.slot} data-side="rear">{rearSlot}</span> : null}
  </span>;
}
